import Lottie from "lottie-react";
import animationData from "./lotties/error.json";

const ErrorSpinner = (props) => {
  return (
    <div className="lottie-wrapper">
      <Lottie
        animationData={animationData}
        style={{ height: props.height, width: props.width, objectFit: "cover" }}
      />
    </div>
  );
};

export default ErrorSpinner;
